<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" style="margin-bottom: 50px">
      <div class="col-md-12">
        <b-card style="margin-bottom: 130px;">
          <div v-show="show" class="alert alert-danger alert-dismissible fade show" role="alert">
            <span v-for="(err, index) in validation_errors" :key="index">
              {{ err[0] }} <br />
            </span>
          </div>

          <form action="">
            <div class="form-row">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="ep_type_id">Affected type <span class="c-required">*</span></label>
                <select v-model="trainee.c_ep_type_id" v-validate="'required'" name="ep_type_id" id="ep_type_id"
                  class="form-control form-control-sm">
                  <option selected disabled :value="''">Select Affected Type</option>
                  <option v-for="(ep, index) in ep_types" :key="index" :value="ep.id">{{ ep.id }} : {{
                    ep.desc }}
                  </option>
                </select>
                <div class="invalid-feedback">
                  Please select an affected type.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="form_number">Form No/ Unique ID <span class="c-required">*</span></label>
                <input type="number" v-model="trainee.form_no" v-validate="'required|max:6|min:2'" id="form_number"
                  name="form_number" class="form-control form-control-sm" placeholder="Form number/ Unique ID" />
                <div class="invalid-feedback">
                  Please enter form number.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="mobile_number">Mobile No. <span class="c-required">*</span></label>
                <input type="number" v-model="trainee.mobile" v-validate="'required|length:11'" id="mobile_number"
                  name="mobile_number" class="form-control form-control-sm" placeholder="Mobile number" />
                <div class="invalid-feedback">
                  Please enter mobile number.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="mobile_alt">Mobile No(Family)</label>
                <input type="number" v-model="trainee.mobile_alt" v-validate="'length:11'" id="mobile_alt"
                  name="mobile_alt" class="form-control form-control-sm" placeholder="Mobile number(family)" />
                <div class="invalid-feedback">
                  Please enter mobile number(Family).
                </div>
              </div>
            </div>

            <div class="form-row mt-2">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="nid" class="col-form-label col-form-label-sm">
                  <span v-if="trainee.id_type === 'N'">National ID </span>
                  <span v-if="trainee.id_type === 'P'">Passport No. </span>
                  <span v-if="trainee.id_type === 'B'">Birth Certificate No.</span>
                </label>
                <div class="row m-0">
                  <div class="col-3 p-0">
                    <select class="form-control form-control-sm" v-model="trainee.id_type">
                      <option value="N">NID</option>
                      <option value="P">Passport</option>
                      <option value="B">Birth</option>
                    </select>
                  </div>
                  <div class="col-9 p-0">
                    <input type="text" v-model="trainee.nid" v-validate="{ regex: /^[a-zA-Z0-9_.-]*$/, min: 6 }" id="nid"
                      name="nid" class="form-control form-control-sm" placeholder="Enter number" />
                  </div>
                  <div class="invalid-feedback">
                    Please enter a valid number.
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="hh_number">1.1 Household No.</label>
                <input text="number" v-model="trainee.household_number" id="hh_number" name="hh_number"
                  class=" form-control form-control-sm" placeholder="Household number" />
                <div class="invalid-feedback">
                  Please enter household number.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="hhh_name">1.2 Trainee Name<span class="c-required">*</span></label>
                <input type="text" v-model="trainee.name" v-validate="{ required: true, regex: /^[a-zA-Z\.\s]*$/ }"
                  id="hhh_name" name="hhh_name" class=" form-control form-control-sm"
                  placeholder="Affected person name" />
                <div class="invalid-feedback">
                  Please enter affected person name.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="loss_types">Loss Types</label>
                <multiselect v-model="trainee.loss_types" :multiple="true" :clear-on-select="false"
                  :preserve-search="true" label="desc" track-by="id" id="loss_types" name="loss_types"
                  :preselect-first="true" :options="c_loss_types" v-validate="{ required: false }"
                  placeholder="Select loss types">
                </multiselect>
                <div class="text-danger" style="margin-top: 0.25rem; font-size: 0.75rem;" v-if="errors.has('loss_types')">
                  Loss types is required</div>
              </div>
            </div>

            <div class="form-row mt-2">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="father_husband_name">
                  <span v-if="trainee.father_hus_type === 'F'">1.3 Guardian name </span>
                  <span v-if="trainee.father_hus_type === 'H'">1.3 Husband Name </span>
                  <span v-if="trainee.father_hus_type === 'S'">1.3 Spouse Name </span>
                </label>
                <div class="row m-0">
                  <div class="col-3 p-0">
                    <select v-model="trainee.father_hus_type" id="father_hus_type" name="father_hus_type"
                      class="form-control form-control-sm">
                      <option value="F">Guardian</option>
                      <option value="H">Husband</option>
                      <option value="S">Spouse</option>
                    </select>
                  </div>
                  <div class="col-9 p-0">
                    <input type="text" v-model="trainee.father_husband_name"
                      v-validate="{ required: false, regex: /^[a-zA-Z\.\s]*$/ }" id="father_husband_name"
                      name="father_husband_name" class=" form-control form-control-sm"
                      placeholder="Father/Husband name" />
                    <div class="invalid-feedback">
                      Please enter Guardian/Husband/Spouse name.
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="mother_name">1.4 Mother Name </label>
                <input type="text" v-model="trainee.mother_name"
                  v-validate="{ required: false, regex: /^[a-zA-Z\.\s]*$/ }" id="mother_name" name="mother_name"
                  class=" form-control form-control-sm" placeholder="Mother's name" />
                <div class="invalid-feedback">
                  Please enter Mother's name.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="dob">1.5 Date of Birth </label>
                <datepicker v-model="trainee.dob" v-validate="{ required: false }" id="dob" name="date_of_birth"
                  :format="customDateDob" :disabled-dates="disabledDates" :input-class="'form-control form-control-sm'"
                  placeholder="Date of Birth"></datepicker>
                <div class="text-danger" style="margin-top: 0.25rem; font-size: 0.75rem;"
                  v-if="errors.has('date_of_birth')">
                  Date of birth is required
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="gender">1.6 Gender <span class="c-required">*</span></label>
                <select v-model="trainee.c_gender_id" v-validate="'required'" id="gender" name="gender"
                  class="form-control form-control-sm">
                  <option selected disabled :value="''">Select Gender</option>
                  <option v-for="(gender, index) in genders" :key="index" :value="gender.id">{{ gender.id
                  }} : {{ gender.desc }}
                  </option>
                </select>
                <div class="invalid-feedback">
                  Please select a gender.
                </div>
              </div>
            </div>

            <div class="form-row mt-2">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="religion">1.7 Religion</label>
                <select v-model="trainee.c_religion_id" id="religion" name="religion"
                  class="form-control form-control-sm">
                  <option selected disabled :value="''">Select a Religion</option>
                  <option v-for="(religion, index) in religions" :key="index" :value="religion.id">{{
                    religion.id }} : {{ religion.desc }}
                  </option>
                </select>
                <div class="invalid-feedback">
                  Please select a religion.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="education">1.8 Education </label>
                <select v-model="trainee.c_education_id" id="education" name="education"
                  class="form-control form-control-sm">
                  <option selected disabled :value="''">Select a Education</option>
                  <option v-for="(education, index) in educations" :key="index" :value="education.id">{{
                    education.id }} : {{ education.desc }}
                  </option>
                </select>
                <div class="invalid-feedback">
                  Please select a Education.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="marital_status">1.9 Marital Status </label>
                <select v-model="trainee.c_marital_status_id" id="marital_status" name="marital_status"
                  class="form-control form-control-sm">
                  <option selected disabled :value="''">Select a status</option>
                  <option v-for="(marital_status, index) in marital_statuses" :key="index" :value="marital_status.id">{{
                    marital_status.id }} : {{ marital_status.desc
  }}
                  </option>
                </select>
                <div class="invalid-feedback">
                  Please select marital status.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="occupation">1.10 Main Occupation </label>
                <select v-model="trainee.c_occupation_id" id="occupation" name="occupation"
                  class="form-control form-control-sm">
                  <option selected disabled :value="''">Select an occupation</option>
                  <option v-for="(occupation, index) in occupations" :key="index" :value="occupation.id">
                    {{ occupation.id }} : {{ occupation.desc }}
                  </option>
                </select>
                <div class="invalid-feedback">
                  Please select occupation.
                </div>
              </div>
            </div>

            <div class="form-row mt-2">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="village">1.11 Village</label>
                <select v-model="trainee.c_village_id" id="village" name="village" class="form-control form-control-sm"
                  @change="getAddress(trainee.c_village_id)">
                  <option selected disabled :value="''">Select a village
                  </option>
                  <option v-for="(village, index) in villages" :key="index" :value="village.id">{{
                    village.id }} : {{ village.desc }}
                  </option>
                </select>
                <div class="invalid-feedback">
                  Please select Village.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="mouza">1.12 Mouza </label>
                <select v-model="trainee.c_mouza_id" id="mouza" name="mouza" class="form-control form-control-sm"
                  disabled>
                  <option selected disabled :value="''">Select a mouza</option>
                  <option v-for="(mouza, index) in mouzas" :key="index" :value="mouza.id">{{ mouza.id }} :
                    {{ mouza.desc }}
                  </option>
                </select>
                <div class="invalid-feedback">
                  Please select Mouza.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="union">1.13 Union </label>
                <select v-model="trainee.c_union_id" id="union" name="union" class="form-control form-control-sm"
                  disabled>
                  <option selected disabled :value="''">Select a union</option>
                  <option v-for="(union, index) in unions" :key="index" :value="union.id">{{ union.id }} :
                    {{ union.desc }}
                  </option>
                </select>
                <div class="invalid-feedback">
                  Please select Union.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="upazila">1.14 Upazila </label>
                <select v-model="trainee.c_upazila_id" id="upazila" name="upazila" class="form-control form-control-sm"
                  disabled>
                  <option selected disabled :value="''">Select a upazila
                  </option>
                  <option v-for="(upazilla, index) in upazillas" :key="index" :value="upazilla.id">{{
                    upazilla.id }} : {{ upazilla.desc }}
                  </option>
                </select>
                <div class="invalid-feedback">
                  Please select upazila.
                </div>
              </div>
            </div>

            <div class="form-row mt-2">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="district">1.15 District </label>
                <select v-model="trainee.c_district_id" id="district" name="district" class="form-control form-control-sm"
                  disabled>
                  <option selected disabled :value="''">Select a district
                  </option>
                  <option v-for="(district, index) in districts" :key="index" :value="district.id">{{
                    district.id }} : {{ district.desc }}
                  </option>
                </select>
                <div class="invalid-feedback">
                  Please select district.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="division">Division </label>
                <select v-model="trainee.c_division_id" id="division" name="division" class="form-control form-control-sm"
                  disabled>
                  <option selected disabled :value="''">Select a division
                  </option>
                  <option v-for="(division, index) in divisions" :key="index" :value="division.id">{{
                    division.id }} : {{ division.desc }}
                  </option>
                </select>
                <div class="invalid-feedback">
                  Please select division.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="family_income">1.16 Family Yearly Income </label>
                <input type="number" v-model="trainee.yearly_income" v-validate="'numeric'" id="family_income"
                  name="family_income" class="form-control form-control-sm" placeholder="Family Yearly Income" />
                <div class="invalid-feedback">
                  Please enter family yearly income.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="affected_plots">1.17 Affected Land Plots </label>
                <input type="text" v-model="trainee.affected_plots" id="affected_plots" name="affected_plots"
                  class="form-control form-control-sm" placeholder="Affected Land Plots" />
                <div class="invalid-feedback">
                  Please enter plots number
                </div>
              </div>
            </div>

            <div class="form-row mt-2">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="affected_khatians">Affected Khatians </label>
                <input type="text" v-model="trainee.affected_khatians" id="affected_khatians" name="affected_khatians"
                  class="form-control form-control-sm" placeholder="Affected and Khatians" />
                <div class="invalid-feedback">
                  Please enter Affected and Khatians
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="affected_mouzas">Affected Mouzas </label>
                <input type="text" v-model="trainee.affected_mouzas" id="affected_mouzas" name="affected_mouzas"
                  class="form-control form-control-sm" placeholder="Affected Land Mouzas" />
                <div class="invalid-feedback">
                  Please enter Affected Land Mouzas
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="present_address">1.18 Present Address</label>
                <input type="text" v-model="trainee.address" id="present_address" name="present_address"
                  class="form-control form-control-sm" placeholder="Present address" />
                <div class="invalid-feedback">
                  Please enter present address
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="present_address">Permanent Address </label>
                <input type="text" v-model="trainee.permanent_address" id="permanent_address" name="permanent_address"
                  class="form-control form-control-sm" placeholder="Present address" />
                <div class="invalid-feedback">Please enter permanent address</div>
              </div>
            </div>

            <div class="form-row mt-2">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="before_any_training">1.19 Received any Training before? <span
                    class="c-required">*</span></label>
                <select v-model="trainee.previous_training" id="before_any_training" name="before_any_training"
                  class="form-control form-control-sm">
                  <option selected value="0">No</option>
                  <option value="1">Yes</option>
                </select>
                <div class="invalid-feedback">
                  Please enter yes/no
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="training_duration">1.20 Training Duration</label>
                <input type="text" v-model="trainee.previous_training_duration" id="training_duration"
                  name="training_duration" class=" form-control form-control-sm"
                  placeholder="Previous training duration" />
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="specific_skills">1.21 Any specific Skills</label>
                <input type="text" v-model="trainee.specific_skills" id="specific_skills" name="specific_skills"
                  class=" form-control form-control-sm" placeholder="Specific skills" />
              </div>

              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="c_driving_license_id">1.22 Driving license information</label>
                <select v-model="trainee.c_driving_license_id" v-validate="'required'" id="c_driving_license_id"
                  name="c_driving_license_id" class="form-control form-control-sm">
                  <option value="1">Learner</option>
                  <option value="2">Finger Print</option>
                  <option value="3">License Available</option>
                  <option value="4">N/A</option>
                </select>
                <div class="invalid-feedback">
                  Please select license info
                </div>
              </div>

            </div>

            <div class="form-row mt-2">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="is_hhh">Are you Household head?</label>
                <select v-model="trainee.is_household_head" id="is_hhh" name="is_hhh"
                  class="form-control form-control-sm">
                  <option value="0">No</option>
                  <option value="1">Yes</option>
                  <option value="2">N/A</option>
                </select>
                <div class="invalid-feedback">
                  Please enter yes/no
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="is_representative">2.0 Representative will receive training?</label>
                <select v-model="trainee.is_representative" id="is_representative" name="is_representative"
                  class="form-control form-control-sm">
                  <option selected value="0">No</option>
                  <option value="1">Yes</option>
                  <option value="2">N/A</option>
                </select>
                <div class="invalid-feedback">
                  Please enter yes/no
                </div>
              </div>
            </div>

            <!-- <div class="mt-1">
                            <b-button v-b-modal.add-field-book @click="$bvModal.show('add-field-book'), resetForm()"
                                variant="success">
                                Add Field Book
                                <i class="fas fa-plus"></i>
                            </b-button>
                            <div class="bg-white rounded box-shadow p-3">
                                <b-modal id="add-field-book" size="lg" title="Add Field Book" hide-footer>
                                    <div class="modal-content bg-white rounded box-shadow">
                                        <div class="form-row">
                                            <div class="col-md-6 col-sm-6 col-lg-6">
                                                <label for="c_village_id"
                                                    class="col-form-label col-form-label-sm">Village</label>
                                                <select v-model="field_book_search.c_village_id" id="c_village_id"
                                                    name="village" class="form-control form-control-sm">
                                                    <option selected :value="''">Select a village</option>
                                                    <option v-for="(village, index) in villages" :key="index"
                                                        :value="village.id">{{ village.id }} : {{ village.desc }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <form action="">
                                            <div class="form-row">
                                                <div class="col-md-12 col-sm-12 col-lg-12">
                                                    <label for="field_book_id" class="col-form-label col-form-label-sm">
                                                        Filed Book <span class="c-required">*</span></label>
                                                    <select v-model="trainee.field_book_id" v-validate="{ required: true }"
                                                        @change="getFieldBookInfo(trainee.field_book_id)" id="field_book_id"
                                                        name="field_book_id" class="form-control form-control-sm">
                                                        <option selected :value="''">Select a Filed Book</option>
                                                        <option v-for="(field_book, index) in field_books"
                                                            :disabled="field_book.status_id == 1"
                                                            :style="field_book.status_id == 1 ? 'background-color: #6c757d; color: #fff' : ''"
                                                            :key="index" :value="field_book.id">{{ field_book.field_book_no
                                                            }} : {{ field_book.name_bn }} <span
                                                                v-if="field_book.status_id == 1">- {{ field_book.remarks
                                                                }}</span></option>
                                                    </select>
                                                    <div class="invalid-feedback">
                                                        Please Select Filed Book
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <input type="hidden" v-model="field_book.id" name="id" id="id" />
                                                <div class="col-md-6 col-sm-6 col-lg-4">
                                                    <label for="name_bn"
                                                        class="col-form-label col-form-label-sm">Name</label>
                                                    <input type="text" disabled v-model="field_book.name_bn" name="name_bn"
                                                        id="name_bn" class="custom-select custom-select-sm" />
                                                </div>
                                                <div class="col-md-6 col-sm-6 col-lg-4">
                                                    <label for="father_name_bn"
                                                        class="col-form-label col-form-label-sm">Father`s Name</label>
                                                    <input type="text" disabled v-model="field_book.father_name_bn"
                                                        name="father_name_bn" id="father_name_bn"
                                                        class="custom-select custom-select-sm" />
                                                </div>
                                                <div class="col-md-6 col-sm-6 col-lg-4">
                                                    <label for="mother_name_bn"
                                                        class="col-form-label col-form-label-sm">Mother`s Name</label>
                                                    <input type="text" disabled v-model="field_book.mother_name_bn"
                                                        name="mother_name_bn" id="mother_name_bn"
                                                        class="custom-select custom-select-sm" />
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-md-6 col-sm-6 col-lg-4">
                                                    <label for="field_book_no"
                                                        class="col-form-label col-form-label-sm">Field Book No</label>
                                                    <input type="text" disabled v-model="field_book.field_book_no"
                                                        name="field_book_no" id="field_book_no"
                                                        class="custom-select custom-select-sm" />
                                                </div>
                                                <div class="col-md-6 col-sm-6 col-lg-4">
                                                    <label for="filed_book_sub_no"
                                                        class="col-form-label col-form-label-sm">Field Book Sub no.</label>
                                                    <input type="text" disabled v-model="field_book.filed_book_sub_no"
                                                        name="filed_book_sub_no" id="filed_book_sub_no"
                                                        class="custom-select custom-select-sm" />
                                                </div>
                                                <div class="col-md-6 col-sm-6 col-lg-4">
                                                    <label for="book_no" class="col-form-label col-form-label-sm">Book
                                                        No.</label>
                                                    <input type="text" disabled v-model="field_book.book_no" name="book_no"
                                                        id="book_no" class="custom-select custom-select-sm" />
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-md-6 col-sm-6 col-lg-4">
                                                    <label for="reference_book_type"
                                                        class="col-form-label col-form-label-sm">Type</label>
                                                    <input type="text" disabled v-model="field_book.reference_book_type"
                                                        name="reference_book_type" id="reference_book_type"
                                                        class="custom-select custom-select-sm" />
                                                </div>
                                            </div>
                                            <div class="form-row mt-2 mb-1">
                                                <div class="float-right">
                                                    <b-button size="sm" variant="success" class="form-control-sm"
                                                        @click="fieldBookSave(field_book)">Ok</b-button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </b-modal>
                            </div>
                        </div>
                        <div v-if="trainee_field_books.length > 0">
                            <div class="table">
                                <thead>
                                    <tr>
                                        <th>SL</th>
                                        <th>Name</th>
                                        <th>Name Bn</th>
                                        <th>Father's Name</th>
                                        <th>Father's Name Bn</th>
                                        <th>Field Book No</th>
                                        <th>Field Book Sub no.</th>
                                        <th>Book No.</th>
                                        <th>Type</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(trainee_field_book, index) in trainee_field_books" :key="index">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ trainee_field_book.name }}</td>
                                        <td>{{ trainee_field_book.name_bn }}</td>
                                        <td>{{ trainee_field_book.father_name }}</td>
                                        <td>{{ trainee_field_book.father_name_bn }}</td>
                                        <td>{{ trainee_field_book.field_book_no }}</td>
                                        <td>{{ trainee_field_book.filed_book_sub_no }}</td>
                                        <td>{{ trainee_field_book.book_no }}</td>
                                        <td>{{ trainee_field_book.reference_book_type }}</td>
                                        <td>
                                            <b-button variant="danger"
                                                class="btn btn-warning btn-xs waves-effect waves-light"
                                                @click.prevent="softDelete(index)">
                                                <i class="far fa-trash-alt"></i>
                                            </b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </div>
                        </div>
                        <hr /> -->

            <div class="mt-3 bg-gray " v-if="trainee.is_representative == 1">
              <h5>Representative Info</h5>

              <div class="form-row mt-2">
                <div class="col-md-6 col-sm-6 col-lg-3">
                  <label for="rep_person_name" class="col-form-label col-form-label-sm">2.1 Name of
                    Representative/Trainee <span class="c-required">*</span></label>
                  <input type="text" v-model="trainee.rep_name" v-validate="{ required: true, regex: /^[a-zA-Z\.\s]*$/ }"
                    id="rep_person_name" name="rep_person_name" class="form-control form-control-sm"
                    placeholder="Name of Representative/Trainee" />
                  <div class="invalid-feedback">Please Representative Name</div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-3">
                  <label for="rep_family_relation" class="col-form-label col-form-label-sm">2.2 Relation
                    With HH <span class="c-required">*</span></label>
                  <select v-model="trainee.c_rep_relation_id" v-validate="'required'" id="rep_family_relation"
                    name="rep_family_relation" class="custom-select custom-select-sm">
                    <option selected value="">Select Relation</option>

                    <option v-for="(relation, index) in family_relations" :key="index" :value="relation.id">{{ relation.id
                    }} : {{ relation.desc }}
                    </option>
                  </select>

                  <div class="invalid-feedback">
                    Please Select Valid Family Relation
                  </div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-3">
                  <label for="father_hus_type">
                    <span v-if="trainee.rep_father_hus_type === 'F'">1.3 Guardian Name <span
                        class="c-required">*</span></span>
                    <span v-if="trainee.rep_father_hus_type === 'H'">1.3 Husband Name <span
                        class="c-required">*</span></span>
                    <span v-if="trainee.rep_father_hus_type === 'S'">1.3 Spouse Name. <span
                        class="c-required">*</span></span>
                  </label>
                  <div class="row m-0">
                    <div class="col-3 p-0">
                      <select v-model="trainee.rep_father_hus_type" v-validate="{ required: true }"
                        name="rep_father_husband_name" class="form-control form-control-sm">
                        <option value="F">Guardian</option>
                        <option value="H">Husband</option>
                        <option value="S">Spouse</option>
                      </select>
                    </div>
                    <div class="col-9 p-0">
                      <input type="text" v-model="trainee.rep_father_husband_name"
                        v-validate="{ required: true, regex: /^[a-zA-Z\.\s]*$/ }" name="rep_father_husband_name"
                        class=" form-control form-control-sm" placeholder="Guardian/Husband/Spouse name" />
                      <div class="invalid-feedback">
                        Please enter Guardian/Husband/Spouse name.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-3">
                  <label for="rep_mother_name" class="col-form-label col-form-label-sm">2.4 Mothers Name
                    <span class="c-required">*</span></label>
                  <input type="text" v-model="trainee.rep_mother_name"
                    v-validate="{ required: true, regex: /^[a-zA-Z\.\s]*$/ }" id="rep_mother_name" name="rep_mother_name"
                    class="form-control form-control-sm" placeholder="Mothers Name" />
                  <div class="invalid-feedback">
                    Please Provide Mother's Name
                  </div>
                </div>
              </div>

              <div class="form-row mt-2">
                <div class="col-md-6 col-sm-6 col-lg-3">
                  <label for="rep_date_of_birth" class="col-form-label col-form-label-sm">2.5 Date Of
                    Birth <span class="c-required">*</span></label>
                  <datepicker :value="trainee.rep_dob" v-validate="'required'" id="rep_date_of_birth"
                    name="rep_date_of_birth" :format="customDateRepDob" :input-class="'form-control form-control-sm'"
                    placeholder="Date of Birth">
                  </datepicker>
                  <div v-if="errors.has('rep_date_of_birth')" class="text-danger"
                    style="margin-top: 0.25rem; font-size: 0.75rem;">
                    Date of birth is required
                  </div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-3">
                  <label for="rep_gender" class="col-form-label col-form-label-sm">2.6 Gender <span
                      class="c-required">*</span></label>
                  <select v-model="trainee.c_rep_gender_id" v-validate="'required'" id="rep_gender" name="rep_gender"
                    class="custom-select custom-select-sm">
                    <option selected value="">Select Gender</option>
                    <option v-for="(gender, index) in genders" v-bind:value="gender.id" :key="index">{{
                      gender.id }} : {{ gender.desc }}
                    </option>
                  </select>
                  <div class="invalid-feedback">Please Select Valid Gender</div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-3">
                  <label for="rep_occupation" class="col-form-label col-form-label-sm">2.7 Main Occupation
                    <span class="c-required">*</span></label>
                  <select v-model="trainee.c_rep_occupation_id" v-validate="'required'" id="rep_occupation"
                    name="rep_occupation" class="custom-select custom-select-sm">
                    <option selected value="">Select Occupation</option>
                    <option v-for="(occupation, index) in occupations" :key="index" v-bind:value="occupation.id">{{
                      occupation.id }} : {{ occupation.desc }}
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    Please Select Valid Main Occupation
                  </div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-3">
                  <label for="rep_religion" class="col-form-label col-form-label-sm">2.8 Religion <span
                      class="c-required">*</span></label>
                  <select v-model="trainee.c_rep_religion_id" v-validate="'required'" id="rep_religion"
                    name="rep_religion" class="custom-select custom-select-sm">
                    <option selected value="">Select Religion</option>
                    <option v-for="(religion, index) in religions" v-bind:value="religion.id" :key="index">{{ religion.id
                    }} : {{ religion.desc }}
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    Please Select Valid Religion
                  </div>
                </div>
              </div>

              <div class="form-row mt-2">
                <div class="col-md-6 col-sm-6 col-lg-3">
                  <label for="rep_education" class="col-form-label col-form-label-sm">2.9 Education <span
                      class="c-required">*</span></label>
                  <select v-model="trainee.c_rep_education_id" v-validate="'required'" id="rep_education"
                    name="rep_education" class="custom-select custom-select-sm">
                    <option selected disabled :value="''">Select a Education
                    </option>
                    <option v-for="(education, index) in educations" v-bind:value="education.id" :key="index">{{
                      education.id }} : {{ education.desc }}
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    Please Select Valid Education
                  </div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-3">
                  <label for="rep_marital_status" class="col-form-label col-form-label-sm">Marital Status
                    <span class="c-required">*</span></label>
                  <select v-model="trainee.c_rep_marital_status_id" v-validate="'required'" id="rep_marital_status"
                    name="rep_marital_status" class="custom-select custom-select-sm">
                    <option selected value="">2.10 Select Marital Status
                    </option>
                    <option v-for="(marital_status, index) in marital_statuses" v-bind:value="marital_status.id"
                      :key="index">{{ marital_status.id }} : {{
                        marital_status.desc }}
                    </option>
                  </select>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-3">
                  <label for="rep_present_address" class="col-form-label col-form-label-sm">2.11 Present
                    Address <span class="c-required">*</span></label>
                  <textarea v-model="trainee.rep_address" id="rep_present_address" name="rep_present_address" rows="1"
                    cols="33" class="form-control form-control-sm" placeholder="Present Address"></textarea>
                  <div class="invalid-feedback">
                    Please provide Valid Address
                  </div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-3">
                  <label for="rep_permanent_address" class="col-form-label col-form-label-sm">Permanent
                    Address</label>
                  <textarea v-model="trainee.rep_permanent_address" id="rep_permanent_address"
                    name="rep_permanent_address" rows="1" cols="33" class="form-control form-control-sm"
                    placeholder="Permanent Address"></textarea>
                  <div class="invalid-feedback">Please provide Valid Address</div>
                </div>
              </div>

              <div class="form-row mt-2">
                <div class="col-md-6 col-sm-6 col-lg-3">
                  <label for="rep_nid" class="col-form-label col-form-label-sm">
                    <span v-if="trainee.rep_id_type === 'N'">2.12 National ID <span class="c-required">*</span></span>
                    <span v-if="trainee.rep_id_type === 'P'">2.12 Passport No. <span class="c-required">*</span></span>
                    <span v-if="trainee.rep_id_type === 'B'">2.12 Birth Certificate No. <span
                        class="c-required">*</span></span>
                  </label>
                  <div class="row m-0">
                    <div class="col-3 p-0">
                      <select class="form-control form-control-sm" v-model="trainee.rep_id_type">
                        <option value="N">NID</option>
                        <option value="P">Passport</option>
                        <option value="B">Birth</option>
                      </select>
                    </div>
                    <div class="col-9 p-0">
                      <input type="text" v-model="trainee.rep_nid"
                        v-validate="{ required: true, regex: /^[a-zA-Z0-9_.-]*$/, min: 6 }" id="rep_nid" name="rep_nid"
                        class="form-control form-control-sm" placeholder="Start with N./P./B." />
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-3">
                  <label for="rep_mobile_no" class="col-form-label col-form-label-sm">Mobile
                    Number</label>
                  <input type="number" v-model="trainee.rep_mobile" id="rep_mobile_no" name="rep_mobile_no"
                    class="form-control form-control-sm" placeholder="Mobile Number" />
                  <div class="invalid-feedback">
                    Please provide Valid Mobile Number
                  </div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-3">
                  <label for="rep_mobile_alt" class="col-form-label col-form-label-sm">Mobile
                    Number(Family)</label>
                  <input type="number" v-model="trainee.rep_mobile_alt" id="rep_mobile_alt" name="rep_mobile_alt"
                    class="form-control form-control-sm" placeholder="Mobile Number(Family)" />
                  <div class="invalid-feedback">Please provide Valid Mobile Number</div>
                </div>
              </div>
            </div>
            <div class="form-row mt-2">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="trades">3.0 Preferred Training Trades <span class="c-required">*</span></label>
                <multiselect v-model="trainee.trades" v-validate="'required'" :multiple="true" :clear-on-select="false"
                  :preserve-search="true" label="desc" track-by="id" id="trades" :preselect-first="true"
                  :options="pref_train_trades" placeholder="Select training trades">
                </multiselect>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="pref_train_time">4.0 Preferred Training Time <span class="c-required">*</span></label>
                <select v-model="trainee.c_pref_time_id" v-validate="'required'" id="pref_train_time"
                  name="pref_train_time" class="form-control form-control-sm">
                  <option selected disabled :value="''">Preferred Training Time
                  </option>
                  <option v-for="(train_time, index) in pref_train_times" :key="index" :value="train_time.id">{{
                    train_time.desc }}
                  </option>
                </select>
                <div class="invalid-feedback">
                  Please select Preferred Training Time.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="survey_conducted_by">Survey Conducted By</label>
                <select v-model="trainee.survey_conducted_by" id="survey_conducted_by" name="survey_conducted_by"
                  class="form-control form-control-sm">
                  <option selected disabled :value="''">Select Worker who conduct Survey</option>
                  <option v-for="(survey_worker, index) in survey_workers" :key="index" :value="survey_worker.id">{{
                    survey_worker.id }} : {{ survey_worker.name }}</option>
                </select>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="survey_conducted_date" class="col-form-label col-form-label-sm">Survey
                  Date</label>
                <datepicker id="survey_conducted_date" v-model="trainee.survey_conducted_date"
                  :format="customSurveyConductedDate" name="survey_conducted_date" placeholder="Survey Date"></datepicker>
              </div>
            </div>
            <div v-if="userPermission.includes('trainee-edit')" class="form-row mt-4 mb-2">
              <div class="col">
                <button @click.prevent="update" class="btn btn-success">
                  Update Data
                </button>
              </div>
            </div>
          </form>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";

import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";

export default {
  page: {
    title: "Update Trainee",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Datepicker, Multiselect },
  data() {
    return {
      title: "Update Trainee",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Training",
          active: true
        }
      ],

      driving_license_info: "",
      pref_train_trades: [],
      pref_train_times: [],
      ep_types: [],
      villages: [],
      mouzas: [],
      unions: [],
      upazillas: [],
      districts: [],
      divisions: [],
      genders: [],
      religions: [],
      occupations: [],
      marital_statuses: [],
      educations: [],
      family_relations: [],
      c_field_book_sub_serials: [],
      c_loss_types: [],
      data_field_books: [],
      survey_workers: [],
      reference_books: [],
      trainee_field_books: [],
      rest_field_books: [],
      field_book_search: {
        c_village_id: '',
      },
      batch: {},
      current_date: '',

      trainee: {
        trades: [],
        loss_types: [],
        c_ep_type_id: 1,
        form_no: "",
        mobile: "",
        mobile_alt: "",
        nid: "",
        id_type: "N",
        household_number: "",
        name: "",
        father_hus_type: "F",
        father_husband_name: "",
        mother_name: "",
        dob: "",
        c_gender_id: "",
        c_religion_id: 1,
        c_education_id: "",
        c_marital_status_id: "",
        c_occupation_id: "",
        c_village_id: "",
        c_mouza_id: "",
        c_union_id: "",
        c_upazila_id: "",
        c_district_id: "",
        c_division_id: "",
        yearly_income: "",
        affected_plots: "",
        is_representative: 0,
        affected_khatians: "",
        affected_mouzas: "",
        previous_training: 0,
        previous_training_duration: "",
        specific_skills: "",
        c_pref_time_id: "",
        address: "",
        permanent_address: "",
        is_household_head: 1,

        rep_name: "",
        c_rep_relation_id: "",
        rep_father_hus_type: "F",
        rep_father_husband_name: "",
        rep_mother_name: "",
        rep_dob: "",
        c_rep_gender_id: "",
        c_rep_occupation_id: "",
        c_rep_religion_id: 1,
        c_rep_marital_status_id: "",
        rep_nid: "",
        rep_id_type: "N",
        rep_mobile: "",
        rep_mobile_alt: "",
        rep_address: "",
        rep_permanent_address: "",
        survey_conducted_by: "",
        survey_conducted_date: "",
        c_driving_license_id: ""
      },
      field_book: {
        id: '',
        name: '',
        name_bn: '',
        father_name: '',
        father_name_bn: '',
        mother_name: '',
        mother_name_bn: '',
        field_book_no: '',
        filed_book_sub_no: '',
        book_no_desc: '',
        reference_book_type_desc: '',
      },
      validation_errors: {},
      show: false,
      disabledDates: {
        from: new Date(Date.now())
      },
    };
  },

  mounted() {
    this.getCodes();
    this.getTrainee();
    this.getFiledBookCodes();
    this.checkCurrentDate();
  },
  methods: {
    checkCurrentDate() {
      this.current_date = moment().format("YYYY-MM-DD");
    },
    customFieldBookLabel(option) {
      return `${option.field_book_no} - ${option.name ? option.name : option.name_bn}`
    },
    customSurveyConductedDate(date) {
      this.trainee.survey_conducted_date = moment(date).format("YYYY-MM-DD");
      return moment(date).format("YYYY-MM-DD");
    },
    customDateDob(date) {
      this.trainee.dob = moment(date).format("YYYY-MM-DD");
      return moment(date).format("YYYY-MM-DD");
    },
    customDateRepDob(date) {
      this.trainee.rep_dob = moment(date).format("YYYY-MM-DD");
      return moment(date).format("YYYY-MM-DD");
    },
    update() {
      let trainee_id = this.$route.params.trainee_id;

      this.$validator.validate().then(valid => {
        if (valid) {
          http.put("api/trainees/" + trainee_id, this.trainee)
            .then(response => {
              if (!response.data.error) {

                if (response.data.permissionError) {
                  this.$bvToast.toast(response.data.permissionError, {
                    title: "Error",
                    autoHideDelay: 5000,
                    variant: "danger"
                  });
                } else {
                  this.$bvToast.toast(response.data.message, {
                    title: "Success",
                    autoHideDelay: 5000,
                    variant: "success"
                  });
                  this.$router.push("/trainee/view/" + trainee_id);
                }
              }
            })
            .catch(error => {
              this.$bvToast.toast(error.response.data.errors, {
                title: "Success",
                autoHideDelay: 5000,
                variant: "success"
              });
              this.validation_errors = error.response.data.errors;
              this.show = true;
              this.hide();
            });
        }
      });
    },
    getTrainee() {
      let trainee_id = this.$route.params.trainee_id;
      http.get("api/trainees/" + trainee_id + "/edit").then(response => {
        if (!response.data.error) {
          this.trainee = response.data.trainee;

          if (this.trainee.c_driving_license_id == 0) {
            this.trainee.c_driving_license_id = "";
          }
          this.trainee_field_books = response.data.trainee.field_books;
          this.batch = response.data.batch;
          this.rest_field_books = response.data.rest_field_books;
          console.log(this.trainee)
        }
      });
    },
    getAddress(village_id) {
      let village = this.villages.find(v => v.id == village_id);

      let mouza = this.mouzas.find(m => m.id == village.c_mouza_id);
      this.trainee.c_mouza_id = mouza.id;

      let union = this.unions.find(u => u.id == mouza.c_union_id);
      this.trainee.c_union_id = union.id;

      let upazila = this.upazillas.find(d => d.id == union.c_upazila_id);
      this.trainee.c_upazila_id = upazila.id;

      let district = this.districts.find(d => d.id == upazila.c_district_id);
      this.trainee.c_district_id = district.id;

      let division = this.divisions.find(dv => dv.id == district.c_division_id);
      this.trainee.c_division_id = division.id;
    },
    getCodes() {
      http.get("api/trainee/codes").then(response => {
        if (!response.error) {
          let data = response.data;
          this.ep_types = data.ep_types;
          this.genders = data.genders;
          this.unions = data.unions;
          this.villages = data.villages;
          this.districts = data.districts;
          this.upazillas = data.upazillas;
          this.religions = data.religions;
          this.occupations = data.occupations;
          this.mouzas = data.mouzas;
          this.marital_statuses = data.marital_statuses;
          this.educations = data.educations;
          this.divisions = data.divisions;
          this.pref_train_trades = data.pref_train_trades;
          this.pref_train_times = data.pref_train_times;
          this.family_relations = data.family_relations;
          this.c_field_book_sub_serials = data.c_field_book_sub_serials;
          this.c_loss_types = data.c_loss_types;
          this.survey_workers = data.survey_workers;
          this.reference_books = data.reference_books;
          this.driving_license_info = data.driving_license_info
        }
      });
    },
    getFiledBookCodes() {
      let trainee_id = this.$route.params.trainee_id;
      http.get("api/trainee/field-book/code/" + trainee_id).then(response => {
        if (!response.error) {
          let data = response.data;
          this.data_field_books = data.field_books;
        }
      });
    },
    hide() {
      setTimeout(() => {
        this.show = false;
      }, 5000);
    },
    fieldBook(village_id, c_reference_book_id) {

      if (village_id != null && c_reference_book_id != null) {
        var filteredArray = this.data_field_books.filter(element =>
          element.c_village_id === village_id &&
          element.c_reference_book_type_id === c_reference_book_id
        )
      }
      if (village_id != null) {
        var filteredArray = this.data_field_books.filter(element =>
          element.c_village_id === village_id
        )
      }
      if (c_reference_book_id != null) {
        var filteredArray = this.data_field_books.filter(element =>
          element.c_reference_book_type_id === c_reference_book_id
        )
      }
      this.field_books = filteredArray;
    },
    getFieldBookInfo(field_book_id) {
      if (field_book_id) {
        let field_book = this.field_books.find(v => v.id == field_book_id);
        this.field_book.name = field_book.name ? field_book.name : ''
        this.field_book.id = field_book.id ? field_book.id : ''
        this.field_book.name_bn = field_book.name_bn ? field_book.name_bn : ''
        this.field_book.father_name = field_book.father_name ? field_book.father_name : ''
        this.field_book.father_name_bn = field_book.father_name_bn ? field_book.father_name_bn : ''
        this.field_book.mother_name = field_book.mother_name ? field_book.mother_name : ''
        this.field_book.mother_name_bn = field_book.mother_name_bn ? field_book.mother_name_bn : ''
        this.field_book.field_book_no = field_book.field_book_no ? field_book.field_book_no : ''
        this.field_book.filed_book_sub_no = field_book.filed_book_sub_no ? field_book.filed_book_sub_no : ''
        this.field_book.book_no_desc = field_book.book_no ? field_book.book_no.desc : ''
        this.field_book.reference_book_type_desc = field_book.reference_book_type ? field_book.reference_book_type.desc : ''
      }
    },
    fieldBookUpdate(field_book) {
      this.field_book = {}
      let trainee_id = this.$route.params.trainee_id;
      http.post("api/trainees/field-book/" + trainee_id, field_book).then(response => {
        if (!response.data.error) {
          this.trainee_field_books.push(response.data.field_book);
          this.$bvModal.hide('update-field-book')
          this.trainee.field_books = {}
        }
      });
    },
    softDelete(index) {
      this.trainee_field_books.splice(index, 1)
    },
    resetForm() {

    },
  },
  computed: {
    userPermission() {
      return this.$store.state.user
    },
    field_books() {
      const c_village_id = this.field_book_search.c_village_id
      const c_reference_book_id = this.field_book_search.c_reference_book_id
      var filteredArray = []

      if (c_village_id != null) {
        filteredArray = this.data_field_books.filter(element =>
          element.c_village_id == c_village_id
        )
      }

      return filteredArray;

    }
  },
  created() {
    this.$store.dispatch('getUserPermission')
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.c-required {
  color: red;
}

.vdp-datepicker input {
  width: 100%;
  border-radius: 3px;
  border: 1px solid #ced4da;
  height: 30px;
  padding-left: 15px;
  color: #6b757d;
}
</style>
